// Portuguese (Brazil) translation for ag-Grid
// using this as 'pt' without region for now...

export default {
    // Set Filter
    selectAll: '(Selecionar tudo)',
    selectAllSearchResults: '(Selecionar todos os resultados da busca)',
    searchOoo: 'Buscar...',
    blanks: '(Em branco)',
    noMatches: 'Nenhuma correspondência',

    // Number Filter & Text Filter
    filterOoo: 'Filtrar...',
    equals: 'Igual a',
    notEqual: 'Diferente de',
    empty: 'Escolha uma opção',

    // Number Filter
    lessThan: 'Menor que',
    greaterThan: 'Maior que',
    lessThanOrEqual: 'Menor ou igual a',
    greaterThanOrEqual: 'Maior ou igual a',
    inRange: 'No intervalo',
    inRangeStart: 'até',
    inRangeEnd: 'de',

    // Text Filter
    contains: 'Contém',
    notContains: 'Não contém',
    startsWith: 'Começa com',
    endsWith: 'Termina com',

    // Date Filter
    dateFormatOoo: 'aaaa-mm-dd',

    // Filter Conditions
    andCondition: 'E',
    orCondition: 'OU',

    // Filter Buttons
    applyFilter: 'Aplicar',
    resetFilter: 'Redefinir',
    clearFilter: 'Limpar',
    cancelFilter: 'Cancelar',

    // Filter Titles
    textFilter: 'Filtro de texto',
    numberFilter: 'Filtro de número',
    dateFilter: 'Filtro de data',
    setFilter: 'Filtro de conjunto',

    // Side Bar
    columns: 'Colunas',
    filters: 'Filtros',

    // columns tool panel
    pivotMode: 'Modo dinâmico',
    groups: 'Grupos de linhas',
    rowGroupColumnsEmptyMessage: 'Arraste aqui para definir grupos de linhas',
    values: 'Valores',
    valueColumnsEmptyMessage: 'Arraste aqui para agregar',
    pivots: 'Rótulos de coluna',
    pivotColumnsEmptyMessage: 'Arraste aqui para definir rótulos de coluna',

    // Header of the Default Group Column
    group: 'Grupo',

    // Other
    loadingOoo: 'Carregando...',
    noRowsToShow: 'Nenhuma linha para mostrar',
    enabled: 'Habilitado',

    // Menu
    pinColumn: 'Fixar coluna',
    pinLeft: 'Fixar à esquerda',
    pinRight: 'Fixar à direita',
    noPin: 'Não fixar',
    valueAggregation: 'Agregação de valores',
    autosizeThiscolumn: 'Ajustar automaticamente esta coluna',
    autosizeAllColumns: 'Ajustar automaticamente todas as colunas',
    groupBy: 'Agrupar por',
    ungroupBy: 'Desagrupar por',
    resetColumns: 'Redefinir colunas',
    expandAll: 'Expandir tudo',
    collapseAll: 'Recolher tudo',
    copy: 'Copiar',
    ctrlC: 'Ctrl+C',
    copyWithHeaders: 'Copiar com cabeçalhos',
    paste: 'Colar',
    ctrlV: 'Ctrl+V',
    export: 'Exportar',
    csvExport: 'Exportar CSV',
    excelExport: 'Exportar Excel',

    // Enterprise Menu Aggregation and Status Bar
    sum: 'Soma',
    min: 'Mín',
    max: 'Máx',
    none: 'Nenhum',
    count: 'Contagem',
    avg: 'Média',
    filteredRows: 'Filtradas',
    selectedRows: 'Selecionadas',
    totalRows: 'Total de linhas',
    totalAndFilteredRows: 'Linhas',
    more: 'Mais',
    to: 'a',
    of: 'de',
    page: 'Página',
    nextPage: 'Próxima página',
    lastPage: 'Última página',
    firstPage: 'Primeira página',
    previousPage: 'Página anterior',

    // Enterprise Menu (Charts)
    pivotChartAndPivotMode: 'Gráfico dinâmico e modo dinâmico',
    pivotChart: 'Gráfico dinâmico',
    chartRange: 'Intervalo do gráfico',

    columnChart: 'Coluna',
    groupedColumn: 'Agrupado',
    stackedColumn: 'Empilhado',
    normalizedColumn: '100% empilhado',

    barChart: 'Barra',
    groupedBar: 'Agrupado',
    stackedBar: 'Empilhado',
    normalizedBar: '100% empilhado',

    pieChart: 'Pizza',
    pie: 'Pizza',
    doughnut: 'Rosca',

    line: 'Linha',

    xyChart: 'X Y (Dispersão)',
    scatter: 'Dispersão',
    bubble: 'Bolha',

    areaChart: 'Área',
    area: 'Área',
    stackedArea: 'Empilhado',
    normalizedArea: '100% empilhado',

    histogramChart: 'Histograma',

    // Charts
    pivotChartTitle: 'Gráfico dinâmico',
    rangeChartTitle: 'Gráfico de intervalo',
    settings: 'Configurações',
    data: 'Dados',
    format: 'Formato',
    categories: 'Categorias',
    defaultCategory: '(Nenhuma)',
    series: 'Séries',
    xyValues: 'Valores X Y',
    paired: 'Modo pareado',
    axis: 'Eixo',
    navigator: 'Navegador',
    color: 'Cor',
    thickness: 'Espessura',
    xType: 'Tipo X',
    automatic: 'Automático',
    category: 'Categoria',
    number: 'Número',
    time: 'Tempo',
    xRotation: 'Rotação X',
    yRotation: 'Rotação Y',
    ticks: 'Marcações',
    width: 'Largura',
    height: 'Altura',
    length: 'Comprimento',
    padding: 'Preenchimento',
    spacing: 'Espaçamento',
    chart: 'Gráfico',
    title: 'Título',
    titlePlaceholder: 'Título do gráfico - clique duas vezes para editar',
    background: 'Plano de fundo',
    font: 'Fonte',
    top: 'Superior',
    right: 'Direita',
    bottom: 'Inferior',
    left: 'Esquerda',
    labels: 'Rótulos',
    size: 'Tamanho',
    minSize: 'Tamanho mínimo',
    maxSize: 'Tamanho máximo',
    legend: 'Legenda',
    position: 'Posição',
    markerSize: 'Tamanho do marcador',
    markerStroke: 'Traço do marcador',
    markerPadding: 'Preenchimento do marcador',
    itemSpacing: 'Espaçamento de itens',
    itemPaddingX: 'Preenchimento do item X',
    itemPaddingY: 'Preenchimento do item Y',
    layoutHorizontalSpacing: 'Espaçamento horizontal',
    layoutVerticalSpacing: 'Espaçamento vertical',
    strokeWidth: 'Espessura do traço',
    offset: 'Deslocamento',
    offsets: 'Deslocamentos',
    tooltips: 'Dicas de ferramenta',
    callout: 'Chamada',
    markers: 'Marcadores',
    shadow: 'Sombra',
    blur: 'Desfoque',
    xOffset: 'Deslocamento X',
    yOffset: 'Deslocamento Y',
    lineWidth: 'Espessura da linha',
    normal: 'Normal',
    bold: 'Negrito',
    italic: 'Itálico',
    boldItalic: 'Negrito itálico',
    predefined: 'Predefinido',
    fillOpacity: 'Opacidade do preenchimento',
    strokeOpacity: 'Opacidade da linha',
    histogramBinCount: 'Número de compartimentos',
    columnGroup: 'Coluna',
    barGroup: 'Barra',
    pieGroup: 'Pizza',
    lineGroup: 'Linha',
    scatterGroup: 'X Y (Dispersão)',
    areaGroup: 'Área',
    histogramGroup: 'Histograma',
    groupedColumnTooltip: 'Agrupado',
    stackedColumnTooltip: 'Empilhado',
    normalizedColumnTooltip: '100% empilhado',
    groupedBarTooltip: 'Agrupado',
    stackedBarTooltip: 'Empilhado',
    normalizedBarTooltip: '100% empilhado',
    pieTooltip: 'Pizza',
    doughnutTooltip: 'Rosca',
    lineTooltip: 'Linha',
    groupedAreaTooltip: 'Área',
    stackedAreaTooltip: 'Empilhado',
    normalizedAreaTooltip: '100% empilhado',
    scatterTooltip: 'Dispersão',
    bubbleTooltip: 'Bolha',
    histogramTooltip: 'Histograma',
    noDataToChart: 'Nenhum dado disponível para gerar o gráfico.',
    pivotChartRequiresPivotMode: 'O gráfico dinâmico requer que o modo dinâmico esteja habilitado.',
    chartSettingsToolbarTooltip: 'Menu',
    chartLinkToolbarTooltip: 'Vinculado à grade',
    chartUnlinkToolbarTooltip: 'Desvinculado da grade',
    chartDownloadToolbarTooltip: 'Baixar gráfico',

    // ARIA
    ariaHidden: 'oculto',
    ariaVisible: 'visível',
    ariaChecked: 'marcado',
    ariaUnchecked: 'desmarcado',
    ariaIndeterminate:'indeterminado',
    ariaColumnSelectAll: 'Alternar seleção de todas as colunas',
    ariaInputEditor: 'Editor de entrada',
    ariaDateFilterInput: 'Entrada do filtro de data',
    ariaFilterInput: 'Entrada do filtro',
    ariaFilterColumnsInput: 'Entrada do filtro de colunas',
    ariaFilterValue: 'Valor do filtro',
    ariaFilterFromValue: 'Filtrar a partir do valor',
    ariaFilterToValue: 'Filtrar até o valor',
    ariaFilteringOperator: 'Operador de filtragem',
    ariaColumnToggleVisibility: 'alternar visibilidade da coluna',
    ariaColumnGroupToggleVisibility: 'alternar visibilidade do grupo de colunas',
    ariaRowSelect: 'Pressione ESPAÇO para selecionar esta linha',
    ariaRowDeselect: 'Pressione ESPAÇO para desmarcar esta linha',
    ariaRowToggleSelection: 'Pressione Espaço para alternar a seleção da linha',
    ariaRowSelectAll: 'Pressione Espaço para alternar a seleção de todas as linhas',
    ariaSearch: 'Buscar',
    ariaSearchFilterValues: 'Buscar valores do filtro'
}